"use strict";
const $kspace  = require('./kspace');
const $CommFuncs = require('./commfuncs');
const $kutil = require('./kutil');
const kabalaupload = require('@/kabalauploadjs/kabalaupload');
const {
    CryptoJS
} = require('@/kabala3rd/crypto');

;(function (root, factory) {
    if (typeof exports === "object") {
        // CommonJS
        module.exports = exports = factory();
    } else if (typeof define === "function" && define.amd) {
        // AMD
        define([], factory);
    } else {
        // Global (browser)
        root.$kmupload = factory();
    }
}(this, function () {
    /**
     * 上传Api之类的
     * @type {Object}
     */
    const kupload = {
        breakupload: function (spacepath, md5, chunksize) {
            var hitcache = kupload.getcache(spacepath, md5);
            if (!hitcache) {
                return null;
            }
            if (!hitcache.token || !hitcache.ctime || !hitcache.etime) {
                kupload.setcache(spacepath, md5);
                return null;
            }
            if (hitcache.chunksize != ("" + chunksize)) {
                /*** 分片大小不一样，废止 ***/
                kupload.setcache(spacepath, md5);
                return null;
            }
            if (new Date().getTime() - parseFloat(hitcache.ctime) > parseFloat(hitcache.etime)) {
                //过期...
                kupload.setcache(spacepath, md5);
                return null;
            }
            //校验一下:
            var updatas = kupload.queryuploaded(spacepath, hitcache.token); //从持久化的地方获取上传对象
            if (updatas == null || updatas.length <= 0) {
                //过期...
                kupload.setcache(spacepath, md5);
                return null;
            }
            var partnumber = -1;
            for (var i = 0; i < updatas.length; i++) {
                var updata = updatas[i];
                if (updata.partsize != chunksize) {
                    partnumber = i;
                    break;
                }
                if (updata.partnumber > partnumber) {
                    partnumber = updata.partnumber;
                }
            }
            return {"token": hitcache.token, "partnumber": partnumber};
        },
        setcache: function (spacepath, md5, token, tokentime, chunksize) {
            var signature = CryptoJS.HmacSHA1(spacepath + "x" + md5, "kabala");
            var cachekey = CryptoJS.enc.Base64.stringify(signature);
            var cachejson = window.localStorage.getItem("kabala.transfer");
            if (cachejson) {
                cachejson = JSON.parse(cachejson);
            } else {
                cachejson = {};
            }
            if (token) {
                var ctime = new Date().getTime();
                var etime = ctime + tokentime;
                cachejson[cachekey] = JSON.stringify({
                    "token": token,
                    "ctime": new Date().getTime().toString(),
                    "etime": etime.toString(),
                    "chunksize": chunksize.toString()
                });
                window.localStorage.setItem("kabala.transfer", JSON.stringify(cachejson));
            } else {
                delete cachejson[cachekey];
                window.localStorage.setItem("kabala.transfer", JSON.stringify(cachejson));
            }
        },
        getcache: function (spacepath, md5) {
            var signature = CryptoJS.HmacSHA1(spacepath + "x" + md5, "kabala");
            var cachekey = CryptoJS.enc.Base64.stringify(signature);
            var cachejson = window.localStorage.getItem("kabala.transfer");
            if (cachejson) {
                cachejson = JSON.parse(cachejson);
            } else {
                cachejson = {};
            }
            if (cachejson[cachekey]) {
                return JSON.parse(cachejson[cachekey]);
            } else {
                return null;
            }
        },
        /*** 申请一个上传操作 ***/
        askupload: function (spacepath, filemd5, filesize, chunksize) {
            // // console.log(spacepath)
            // console.log('====')
            var res = $kspace.sync.askupload(spacepath, filemd5, filesize, chunksize, 24 * 60 * 60, null);
            kupload.setcache(spacepath, filemd5, res.uptoken, 24 * 60 * 60 * 1000, chunksize);
            return res;
        },
        queryuploaded: function (spacepath, uptoken) {
            return $kspace.sync.queryuploaded(spacepath, uptoken);
        },
        exchangeupload: function (spacepath, uptoken, partnumber) {
            return $kspace.sync.exchangeupload(spacepath, uptoken, partnumber);
        },
        submitupload: function (spacepath, uptoken, meta) {
            var result = $kspace.sync.submitupload(spacepath, uptoken, meta);
            kupload.setcache(spacepath, uptoken);
            return result;
        },
    };
    /**
     * 实例化上传 - 使用时需要 new kupload.upload({..})
     *
     */
    kupload.upload = function (opt) {
        let opts = $CommFuncs.extendAttrs({
            click: '',
            drop: '',
            types: '',
            // types: [],
            multi: false,
            autoNext: true,
            uploaddir: '',
            chunksize: 5242880,
            error: function (file, err) {
            },
            succeed: function (file, node, breadk) {
            },
            before: function (files) {
            },
            progress: function (file, ps) {
            },
            cancel: function (file) {
            },
            complete: function () {
            },
        }, opt);
        // console.log(opts)
        let newupload = new kabalaupload(opts.click, opts.drop, opts.types, opts.multi);
        // 触发下一个
        newupload.triggleNext = (id) => {
            if (id) {
                newupload.removeFile(id);
            }
            let ids = newupload.listFileIds();
            if (ids.length === 0) {
                opts.complete();
                return;
            }
            let file = newupload.getFile(ids[0]);
            newupload.triggleFileHash(file, opts.chunksize);
        };
        // 清空
        newupload.clearTask = () => {
            let ids = newupload.listFileIds();
            if (ids) {
                for (var i = 0; i < ids.length; i++) {
                    newupload.removeFile(ids[i]);
                }
            }
        };
        // 选择一个文件...
        newupload.bindFileAdded((files) => {
            let uploaddir = '';
            if ($CommFuncs.isType(opts.uploaddir, 'function')) {
                uploaddir = opts.uploaddir();
            } else {
                uploaddir = opts.uploaddir;
            }
            if (!uploaddir) {
                /*opts.error(null, new Error('uploaddir is null')); return;*/
            }
            for (let i = 0; i < files.length; i++) {
                files[i].submitpath = uploaddir + files[i].path;
            }
            let c = opts.before(files, this);
            if (c !== false) {
                newupload.triggleNext();
            }
        });
        // 文件md5hash计算完毕事件...
        newupload.bindFileHashed((file) => {
            let filemd5 = file.md5;
            let filesize = file.size;
            let parent = file.submitpath.substring(0, file.submitpath.lastIndexOf("/"));
            try {
                let parentnode = $kspace.sync.getnode(parent);
                if (!parentnode) {
                    parentnode = $kspace.sync.mkdirs(parent);
                }
                let kabalaupload = {};
                let chunksize = opts.chunksize >= filesize ? -1 : opts.chunksize;
                // debugger
                let updata = kupload.breakupload(file.submitpath, file.md5, file.chunksize);
                if (updata) {
                    kabalaupload = kupload.exchangeupload(file.submitpath, updata.token, updata.partnumber);
                } else {

                    kabalaupload = kupload.askupload(file.submitpath, filemd5, filesize, chunksize, 24 * 60 * 60);
                }
                if (kabalaupload.upmethod == 'HIT') {
                    try {
                        let filenode = kupload.submitupload(file.submitpath, kabalaupload.uptoken);
                        opts.succeed(file, filenode, true);
                        if (opts.autoNext) {
                            newupload.triggleNext(file.id);
                        }
                    } catch (e) {
                        opts.error(file, e);
                    }
                    return;
                } else if (kabalaupload.upmethod == 'POST') {
                    // postMultipart上传方式
                    newupload.setUploadParams(kabalaupload.httpurl, 'POST', kabalaupload.httpheaders, true, kabalaupload.httpmultiforms);
                } else if (kabalaupload.upmethod == 'PUT') {
                    // PUT方式上传文件
                    newupload.setUploadParams(kabalaupload.httpurl, 'PUT', kabalaupload.httpheaders, false, null);
                }
                file.submittoken = kabalaupload.uptoken;
                // 触发开始上传
                newupload.triggleFileUpload(file, opts.chunksize, 5);
            } catch (err) {
                opts.error(file, err);
            }
        });
        // 成功上传一个文件
        newupload.bindFileUploadSuccess((file) => {
            try {
                let filenode = kupload.submitupload(file.submitpath, file.submittoken);
                opts.succeed(file, filenode, false);
                if (opts.autoNext) {
                    newupload.triggleNext(file.id);
                }
            } catch (e) {
                opts.error(file, e);
            }
        });
        // 刷新文件上传进度...
        newupload.bindFileUploadProgress((file, loaded) => {
            opts.progress(file, $kutil.toPercent(file.size, loaded));
        });
        // 事件函数--当上传文件传输失败后触发 onFileUploadError(file)
        newupload.bindFileUploadError((errObject) => {
            opts.error(errObject.file, "[" + errObject.code + "]" + errObject.message);
        });
        // 事件函数--当上传文件传输被取消后触发 onFileUploadCancel(file)
        newupload.bindFileUploadCancel((file) => {
            opts.cancel(file);
        });
        // 事件函数--当上传文件分片传输开始后触发 onChunkUploadBegin(file, chunkOffset)
        // 该函数如果返回 true 则表示需要执行数据上传, 如果返回 false 则表示跳过数据上传
        newupload.bindChunkUploadBegin((file, chunkOffset) => {
            if (file.size > file.chunksize) {
                let updata = kupload.breakupload(file.submitpath, file.md5, file.chunksize);
                //计算分片编号:
                let partnumber = chunkOffset / file.chunksize + 1;
                //这里不考虑为不是顺序的上传...
                if (updata) {
                    if (updata.partnumber >= partnumber) { //已上传过...
                        newupload.setChunkSkip(file, chunkOffset);
                        return false;
                    }
                }
                //申请分片上传令牌
                try {
                    let kabalaupload = kupload.exchangeupload(file.submitpath, file.submittoken, partnumber);
                    if (kabalaupload.upmethod == 'POST') {
                        // postMultipart上传方式
                        newupload.setUploadParams(kabalaupload.httpurl, 'POST', kabalaupload.httpheaders, true, kabalaupload.httpmultiforms);
                    } else if (kabalaupload.upmethod == 'PUT') {
                        // PUT方式上传文件
                        newupload.setUploadParams(kabalaupload.httpurl, 'PUT', kabalaupload.httpheaders, false, null);
                    }
                } catch (err) {
                    opts.error(file, err);
                }
            }
            return true;
        });

        // 导出对象, 可以覆盖
        this.uploader = newupload;
        this.opts = opts;
    };

    return kupload;
}));
